import { render, staticRenderFns } from "./Comparative-review-summary.vue?vue&type=template&id=78d9a1cf&scoped=true"
import script from "./Comparative-review-summary.vue?vue&type=script&lang=js"
export * from "./Comparative-review-summary.vue?vue&type=script&lang=js"
import style0 from "./Comparative-review-summary.vue?vue&type=style&index=0&id=78d9a1cf&prod&scoped=true&lang=css"
import style1 from "./Comparative-review-summary.vue?vue&type=style&index=1&id=78d9a1cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d9a1cf",
  null
  
)

export default component.exports